import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { MemberStore } from '@web/service';
import { findArea } from '../routes/routes.model';

/** Sends a member away from an area the backend hides, to the first menu item the root route picks. */
export const areaNotHidden: CanMatchFn = route => {
  const areas = inject(MemberStore).member.value()?.access.areas;
  return findArea(route.path ?? '', areas)?.hidden ? inject(Router).createUrlTree(['/']) : true;
};
